<app-widget-base [title]="title">
  <div class="chart" #chart></div>
</app-widget-base>
